/* eslint-disable react-hooks/rules-of-hooks */
import { useCallback, useState } from 'react';
import DataTable from '@/components/features/data-table/DataTable';
import { useStoreListWithMissingProductList } from '@/services/Store/mockStoreService';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { OnboardingStatusHeader } from '@/components/features/onboarding-status/OnboardingStatusHeader';

const MissingProductListTable = ({ startDate, endDate }) => {
  const navigate = useNavigate();
  const [totalStoresCount, setTotalStoresCount] = useState(0);

  const columns = [
    {
      columnKey: 'storeId',
      header: 'STORE ID',
      cellData: ctx => {
        return (
          <span
            style={{
              cursor: 'pointer',
              color: '#66A5E7',
              textDecoration: 'none'
            }}
            onClick={e => {
              e.stopPropagation(); // Prevent row click from firing
              navigate(`/profile/store/${ctx.row.original.storeId}`);
            }}>
            {ctx.row.original.customerId}
          </span>
        );
      }
    },
    {
      columnKey: 'createdDate',
      header: 'STORE CREATED DATE',
      cellData: ctx => {
        // formate Date MM/DD/YYYY
        return format(new Date(ctx.row.original.createdDate), 'MM/dd/yyyy');
      }
    },
    {
      columnKey: 'routeId',
      header: 'ROUTE ID'
    },
    {
      columnKey: 'routeType',
      header: 'ROUTE TYPE'
    },
    {
      columnKey: 'minimumOrderAmount',
      header: 'MINIMUM ORDER AMOUNT'
    },
    {
      columnKey: 'deliveryDays',
      header: 'DELIVERY DAYS',
      cellData: ctx => {
        if (ctx.row.original.deliveryDays) {
          if (ctx.row.original.deliveryDays.length > 0) {
            return ctx.row.original.deliveryDays.join(', ');
          } else {
            return '-';
          }
        } else {
          return '-';
        }
      }
    },
    {
      columnKey: 'productList',
      header: 'PRODUCT LIST',
      cellData: ctx => {
        if (ctx.row.original.productList) {
          if (ctx.row.original.productList.length > 0) {
            return ctx.row.original.productList.join(', ');
          } else {
            return '-';
          }
        } else {
          return '-';
        }
      }
    },
    {
      columnKey: 'deliveryService',
      header: 'DELIVERY SERVICE'
    },
    {
      columnKey: 'cutoffTime',
      header: 'CUTOFF TIME'
    }
  ];

  const calculateTotalStoresCount = () => {
    return totalStoresCount > 0
      ? totalStoresCount + (totalStoresCount > 1 ? ' Stores' : ' Store')
      : null;
  };

  // Memoize the fetch function so it has access to latest startDate/endDate
  const fetchFunction = useCallback(
    (apiPage, apiPageSize, filters) =>
      useStoreListWithMissingProductList(
        apiPage,
        apiPageSize,
        filters,
        startDate,
        endDate
      ),
    [startDate, endDate]
  );

  return (
    <DataTable
      tableHeader={<OnboardingStatusHeader title='Missing Product List' />}
      subHeader={calculateTotalStoresCount()}
      columns={columns}
      isDark={true}
      showColumnFilters={true}
      onSettingsClicked={() => alert('Settings clicked')}
      selection='multiple'
      idField='storeId'
      pageSize={10}
      enableSorting={true}
      fetchFunction={fetchFunction}
      setTotalStoresCount={setTotalStoresCount}
      downloadFileName='storeview_MX_data.csv'
    />
  );
};

export default MissingProductListTable;
